import LevelG1_1 from "./glenn-1-1";
import LevelG1_2 from "./glenn-1-2";
import LevelG1_3 from "./glenn-1-3";
import LevelG1_4 from "./glenn-1-4";
import LevelG1_5 from "./glenn-1-5";
import LevelG1_6 from "./glenn-1-6";
import LevelG1_7 from "./glenn-1-7";
import LevelG1_8 from "./glenn-1-8";
import LevelG1_9 from "./glenn-1-9";
import LevelG2_1 from "./glenn-2-1";
import LevelG2_2 from "./glenn-2-2";
import LevelG2_3 from "./glenn-2-3";
import LevelG2_4 from "./glenn-2-4";
import LevelG2_5 from "./glenn-2-5";
import LevelG2_6 from "./glenn-2-6";
import LevelG2_7 from "./glenn-2-7";
import LevelG2_8 from "./glenn-2-8";
import LevelG2_9 from "./glenn-2-9";
import LevelG3_1 from "./glenn-3-1";
import LevelG3_2 from "./glenn-3-2";
import LevelG3_3 from "./glenn-3-3";
import LevelG3_4 from "./glenn-3-4";
import LevelG3_5 from "./glenn-3-5";
import LevelG3_6 from "./glenn-3-6";
import LevelG3_7 from "./glenn-3-7";
import LevelG3_8 from "./glenn-3-8";
import LevelG3_9 from "./glenn-3-9";
import LevelG4_1 from "./glenn-4-1";
import LevelG4_2 from "./glenn-4-2";
import LevelG4_3 from "./glenn-4-3";
import LevelG4_4 from "./glenn-4-4";
import LevelG4_5 from "./glenn-4-5";
import LevelG4_6 from "./glenn-4-6";
import LevelG4_7 from "./glenn-4-7";
import LevelG4_8 from "./glenn-4-8";
import LevelG4_9 from "./glenn-4-9";
import LevelD5_1 from "./glenn-drew-5-1";
import LevelD5_2 from "./glenn-drew-5-2";
import LevelD5_3 from "./glenn-drew-5-3";
import LevelD5_4 from "./glenn-drew-5-4";
import LevelD5_5 from "./glenn-drew-5-5";
import LevelD5_6 from "./glenn-drew-5-6";
import LevelD5_7 from "./glenn-drew-5-7";
import LevelD5_8 from "./glenn-drew-5-8";
import LevelD5_9 from "./glenn-drew-5-9";

import { LOCAL_STORAGE_CUSTOM_LEVELS } from "../helpers/consts";
import { getNewLevel } from "../helpers/addNewLevel";

const localLevelsString =
  window.localStorage.getItem(LOCAL_STORAGE_CUSTOM_LEVELS) || "{}";
const parsedCustomLevels = JSON.parse(localLevelsString);

export const LevelMap = {
  // G1
  "1-1": LevelG1_1,
  "1-2": LevelG1_2,
  "1-3": LevelG1_3,
  "1-4": LevelG1_4,
  "1-5": LevelG1_5,
  "1-6": LevelG1_6,
  "1-7": LevelG1_7,
  "1-8": LevelG1_8,
  "1-9": LevelG1_9,
  // G2
  "2-1": LevelG2_1,
  "2-2": LevelG2_2,
  "2-3": LevelG2_3,
  "2-4": LevelG2_4,
  "2-5": LevelG2_5,
  "2-6": LevelG2_6,
  "2-7": LevelG2_7,
  "2-8": LevelG2_8,
  "2-9": LevelG2_9,
  // G3
  "3-1": LevelG3_1,
  "3-2": LevelG3_2,
  "3-3": LevelG3_3,
  "3-4": LevelG3_4,
  "3-5": LevelG3_5,
  "3-6": LevelG3_6,
  "3-7": LevelG3_7,
  "3-8": LevelG3_8,
  "3-9": LevelG3_9,
  // G4
  "4-1": LevelG4_1,
  "4-2": LevelG4_2,
  "4-3": LevelG4_3,
  "4-4": LevelG4_4,
  "4-5": LevelG4_5,
  "4-6": LevelG4_6,
  "4-7": LevelG4_7,
  "4-8": LevelG4_8,
  "4-9": LevelG4_9,
  // G5
  "5-1": LevelD5_1,
  "5-2": LevelD5_2,
  "5-3": LevelD5_3,
  "5-4": LevelD5_4,
  "5-5": LevelD5_5,
  "5-6": LevelD5_6,
  "5-7": LevelD5_7,
  "5-8": LevelD5_8,
  "5-9": LevelD5_9,

  // Custom from Local Storage
  ...parsedCustomLevels,
};

export const createLevelInLevelMap = () => {
  const key = `custom_${Date.now()}`;
  LevelMap[key] = getNewLevel();
  return key;
};
